module.exports = __webpack_public_path__ + "img/prod-1.3dd320ae.jpg";